import React, { ReactElement } from "react";
import styled from "styled-components";
import { Box } from "@cruk/cruk-react-components";
import {
  getFormBrand,
  getFormComponents,
  getFormThemeName,
} from "../configs/single-donation";

type HeaderProps = {
  formName: string;
};

const HeaderFlex = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  max-width: 1020px;
  margin: 0px auto;
`;

const LogoLink = styled.a`
  display: inline-block;
`;

const LogoImage = styled.img<{ $mobileWidth: number; $desktopWidth: number }>`
  display: block;
  height: 40px;
  width: ${({ $mobileWidth }) => $mobileWidth}px;

  @media (min-width: 992px) {
    height: 80px;
    width: ${({ $desktopWidth }) => $desktopWidth}px;
  }
`;

const HeaderContainer = styled.div`
  position: relative;
  border-bottom: 1px solid rgb(198, 198, 198);
  padding: 0px 1.5rem;
  height: 72px;

  @media (min-width: 992px) {
    height: 120px;
  }
`;

const TagLine = styled.p`
  display: none;

  @media (min-width: 992px) {
    flex: 1 1 auto;
    font-family: MuseoSans-500, Calibri, Arial, sans-serif;
    font-weight: 300;
    font-size: 1.5625rem;
    color: rgb(46, 0, 139);
    text-align: center;
    display: block;
  }
`;

const Header = ({ formName }: HeaderProps): ReactElement => {
  const headerConfig = getFormComponents(formName).header;
  const brand = getFormBrand(formName);
  const themeName = getFormThemeName(formName);
  const isSU2C = themeName === "SU2C";
  const isRFL = brand === "RFL";
  const isBMF = brand === "BMF";

  let mobileWidth = 104;
  let desktopWidth = 208;

  if (isSU2C) {
    mobileWidth = 174;
    desktopWidth = 348;
  } else if (isRFL) {
    mobileWidth = 112;
    desktopWidth = 223;
  } else if (isBMF) {
    mobileWidth = 138;
    desktopWidth = 276;
  }

  return (
    <header>
      <Box>
        <HeaderContainer>
          <HeaderFlex>
            <LogoLink
              href={headerConfig.logoUrl}
              title={`${headerConfig.logoTitle} (Opens in a new tab)`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${headerConfig.logoTitle} (Opens in a new tab)`}
            >
              <LogoImage
                $mobileWidth={mobileWidth}
                $desktopWidth={desktopWidth}
                src={headerConfig.logoSrc}
                alt={headerConfig.logoAlt}
              />
            </LogoLink>
            {!isSU2C ? <TagLine>{headerConfig.siteSlogan}</TagLine> : null}
          </HeaderFlex>
        </HeaderContainer>
      </Box>
    </header>
  );
};

export default Header;
